import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";
import styled from "styled-components";

const FilesContainer = styled.div`
  display: grid;
  gap: 24px;

  ${SmallPrint} {
    margin-bottom: 4px;
  }
`;

export default FilesContainer;
